<div class="flex w-full h-full p-30">
  <div class="flex flex-col items-center m-auto text-xl gap-y-30">
    <p>Connecting with GoHighLevel!</p>
  </div>
</div>
